import React from 'react';
import { ShieldCheck, X, Send } from 'lucide-react';

export default function PrivacyModal({ 
  isOpen, 
  setIsOpen, 
  aceptaPrivacidad, 
  setAceptaPrivacidad, 
  enviando, 
  confirmarYEnviar 
}) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '600px', width: '90%' }}>
        <button className="modal-close" onClick={() => setIsOpen(false)}><X size={20} /></button>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', marginBottom: '1.5rem' }}>
          <ShieldCheck size={28} color="var(--primary)" />
          <h2 style={{ margin: 0, fontSize: '1.4rem' }}>Política de Privacidad y Consentimiento</h2>
        </div>
        
        <div style={{ maxHeight: '400px', overflowY: 'auto', padding: '1rem', background: 'var(--bg-surface)', borderRadius: '8px', border: '1px solid var(--border-color)', fontSize: '0.9rem', lineHeight: '1.6', color: 'var(--text-main)', marginBottom: '1.5rem' }}>
          <p>Al utilizar este formulario de solicitudes del Conservador de Bienes Raíces, usted acepta y consiente lo siguiente:</p>
          <ol style={{ paddingLeft: '1.2rem', display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
            <li><strong>Veracidad de la Información:</strong> Declara que toda la información proporcionada (RUT, nombre, datos de contacto y datos registrales) es verídica, exacta y está actualizada. El uso de identidades falsas o la suplantación de identidad podrá derivar en acciones legales correspondientes.</li>
            <li><strong>Tratamiento de Datos Personales:</strong> Autoriza al Conservador de Bienes Raíces a recopilar, almacenar y procesar sus datos personales exclusivamente con el fin de tramitar, gestionar y notificarle sobre la presente solicitud, en conformidad con la Ley N° 19.628 sobre Protección de la Vida Privada.</li>
            <li><strong>Notificaciones y Contacto:</strong> Acepta recibir notificaciones, documentos y enlaces de pago al correo electrónico y/o teléfono proporcionados. Es su responsabilidad revisar dichos canales, incluyendo las bandejas de correo no deseado (Spam).</li>
            <li><strong>Obligación de Pago:</strong> Comprende que el envío de esta solicitud genera la obligación de pagar los aranceles correspondientes una vez que la solicitud sea evaluada y tasada por el Conservador.</li>
            <li><strong>Plazos y Procedimientos:</strong> Entiende que los plazos de entrega de los documentos dependerán del volumen de trabajo y la complejidad de la búsqueda, y que el Conservador se reserva el derecho de rechazar solicitudes que no cumplan con los requisitos legales o que contengan datos insuficientes o erróneos.</li>
          </ol>
        </div>

        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.8rem', marginBottom: '1.5rem', background: 'rgba(var(--primary-rgb), 0.05)', padding: '1rem', borderRadius: '8px' }}>
          <input
            type="checkbox"
            id="acepto-privacidad"
            checked={aceptaPrivacidad}
            onChange={(e) => setAceptaPrivacidad(e.target.checked)}
            style={{ width: '20px', height: '20px', marginTop: '2px', cursor: 'pointer' }}
          />
          <label htmlFor="acepto-privacidad" style={{ cursor: 'pointer', fontSize: '0.95rem', fontWeight: 500, lineHeight: '1.4' }}>
            He leído y acepto la Política de Privacidad y las condiciones para el envío de esta solicitud.
          </label>
        </div>

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
          <button className="btn btn-outline" onClick={() => setIsOpen(false)} disabled={enviando}>
            Cancelar
          </button>
          <button 
            className="btn btn-primary" 
            onClick={confirmarYEnviar} 
            disabled={!aceptaPrivacidad || enviando}
            style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
          >
            {enviando ? (
              <><span className="spinner" style={{ width: 16, height: 16, borderTopColor: 'currentColor' }} /> Enviando...</>
            ) : (
              <><Send size={18} /> Confirmar y Enviar Solicitud</>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
